/* global globalThis */
export function diagnosticUuid() {
    if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
    const bytes = new Uint8Array(16);
    if (globalThis.crypto?.getRandomValues) globalThis.crypto.getRandomValues(bytes);
    else for (let index = 0; index < bytes.length; index++) bytes[index] = Math.floor(Math.random() * 256);
    bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128;
    const hex = Array.from(bytes, value => value.toString(16).padStart(2, "0")).join("");
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function mergeDiagnosticEvents(...groups) {
    const events = new Map();
    for (const group of groups) for (const event of group || []) {
        const previous = events.get(event.id);
        if (!previous || event.revision > previous.revision) events.set(event.id, event);
    }
    return [...events.values()].sort((a, b) => a.started_at.localeCompare(b.started_at));
}

export function matchesDiagnosticRequest(request, browserEvent) {
    if (!request || !browserEvent) return false;
    // A cached response may repeat an old trace header. The v2 client ID identifies this GET.
    return request.client_id ? browserEvent.id === request.client_id : !!request.id && browserEvent.request_id === request.id;
}

export function timingSummary(values) {
    const sorted = values.filter(value => typeof value === "number" && Number.isFinite(value)).sort((a, b) => a - b);
    const length = sorted.length, middle = Math.floor(length / 2);
    return { count: length, min: sorted[0] ?? null, median: length ? (length % 2 ? sorted[middle] : (sorted[middle - 1] + sorted[middle]) / 2) : null, max: sorted[length - 1] ?? null };
}

export function diagnosticComparisons(requests = []) {
    const groups = new Map();
    const selections = new Map();
    for (const request of requests) {
        const cache = request.metadata?.cache_hit === true ? "hit" : request.metadata?.cache_hit === false ? "miss" : "unknown";
        const result = request.status_code >= 400 ? `HTTP ${request.status_code}` : "ok";
        const selectionKey = `${request.route}:${request.target_key || request.id}`;
        if (!selections.has(selectionKey)) selections.set(selectionKey, selections.size + 1);
        const variant = diagnosticVariant(request);
        const key = `${request.route}:${request.target_key || request.id}:${cache}:${result}:${variant}`;
        if (!groups.has(key)) groups.set(key, { route: request.route, target: request.target_key, selection: selections.get(selectionKey), cache, result, variant, rows: [] });
        groups.get(key).rows.push(request);
    }
    return [...groups.values()].map(({ route, target, selection, cache, result, variant, rows }, index) => ({ groupId: index + 1, route, target, selection, cache, result, variant, ...timingSummary(rows.map(row => row.total_ms)), sql: timingSummary(rows.map(row => row.sql_ms)), errors: rows.filter(row => row.status_code >= 400).length }));
}

export function diagnosticVariantName(value) {
    return { optimized: "Ottimizzata", v2: "Prova V2 (storico)", standard: "Standard (storico)", unknown: "Non registrata" }[value] || "Non registrata";
}

export function diagnosticVariant(request) {
    if (request.metadata?.phase_optimized === true) return "optimized";
    return request.metadata?.phase_preview === true ? "v2" : request.metadata?.phase_preview === false ? "standard" : "unknown";
}

export function routePattern(route) {
    const path = route?.matched?.slice(-1)[0]?.path;
    if (!path || !path.startsWith("/") || path.includes("#")) return "/:unknown";
    const segments = path.split("/").filter(Boolean).map(segment => {
        if (segment.startsWith(":")) return segment.match(/^:[A-Za-z_][A-Za-z0-9_]*/)?.[0];
        return /^[A-Za-z0-9_.-]+$/.test(segment) && ![".", ".."].includes(segment) ? segment : null;
    });
    return segments.every(Boolean) ? "/" + segments.join("/") : "/:unknown";
}
